import { render, staticRenderFns } from "./FollowUpViewInfo.vue?vue&type=template&id=5460ca9c&"
import script from "./FollowUpViewInfo.vue?vue&type=script&lang=js&"
export * from "./FollowUpViewInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports